import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import {
  Calendar,
  LayoutDashboard,
  MessageSquareQuote,
  Settings as SettingsIcon,
  Sparkles,
  Tags,
  LogOut,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { useAuth } from '@/lib/auth-context'
import { Button } from '@/components/ui/button'

const nav = [
  { to: '/app', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/app/threads', label: 'Threads', icon: Sparkles },
  { to: '/app/schedule', label: 'Schedule', icon: Calendar },
  { to: '/app/engagement', label: 'Engagement', icon: MessageSquareQuote },
  { to: '/app/topics', label: 'Topics', icon: Tags },
  { to: '/app/settings', label: 'Settings', icon: SettingsIcon },
]

export default function AppShell() {
  const { me, logout } = useAuth()
  const navigate = useNavigate()

  return (
    <div className="flex h-full min-h-screen bg-background">
      <aside className="flex w-60 flex-col border-r bg-card/40">
        <div className="flex h-14 items-center gap-2 border-b px-5">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4"><path d="M22 5.8a8.5 8.5 0 0 1-2.4.7 4.2 4.2 0 0 0 1.8-2.3c-.8.5-1.7.8-2.7 1a4.2 4.2 0 0 0-7.1 3.8A11.9 11.9 0 0 1 3 4.9a4.2 4.2 0 0 0 1.3 5.6c-.7 0-1.3-.2-1.9-.5v.1a4.2 4.2 0 0 0 3.3 4.1 4.3 4.3 0 0 1-1.9.1A4.2 4.2 0 0 0 7.8 17 8.4 8.4 0 0 1 2 19a12 12 0 0 0 6.4 1.9c7.6 0 11.8-6.3 11.8-11.8v-.5A8.4 8.4 0 0 0 22 5.8"/></svg>
          </div>
          <div className="leading-tight">
            <div className="font-semibold">Bluebird</div>
            <div className="text-[11px] text-muted-foreground">Grow on X, honestly</div>
          </div>
        </div>

        <nav className="flex-1 px-2 py-3">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2.5 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground',
                  isActive && 'bg-accent text-accent-foreground font-medium',
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t p-3">
          <div className="mb-2 px-2 text-xs text-muted-foreground">
            <div className="font-medium text-foreground">
              {me?.displayName ?? (me?.x.handle ? `@${me.x.handle}` : 'Signed in')}
            </div>
            {me?.x.handle && me.displayName && <div>@{me.x.handle}</div>}
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start"
            onClick={async () => {
              await logout()
              navigate('/login')
            }}
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-5xl px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
